function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import angular from 'angular';
import { clone } from 'lodash';
import { AccesoDatos } from 'src/_candidato/comun/services/acceso-datos';
var TarjetaMainQuestionComponentCtrl = /*#__PURE__*/function () {
  TarjetaMainQuestionComponentCtrl.$inject = ["$element", "$timeout", "$log", "NotifService", "AccesoDatos"];
  function TarjetaMainQuestionComponentCtrl($element, $timeout, $log, NotifService, AccesoDatos) {
    _classCallCheck(this, TarjetaMainQuestionComponentCtrl);
    _defineProperty(this, "editando", false);
    _defineProperty(this, "form", {
      data: null
    });
    _defineProperty(this, "dirty", false);
    _defineProperty(this, "usosData", {
      visible: false,
      leido: false,
      list: []
    });
    this.$element = $element;
    this.$timeout = $timeout;
    this.$log = $log;
    this.NotifService = NotifService;
    this.AccesoDatos = AccesoDatos;
  }
  return _createClass(TarjetaMainQuestionComponentCtrl, [{
    key: "$onInit",
    value: function $onInit() {
      this.$log.info('[TarjetaMainQuestionComponentCtrl] onInit');
      this.form.data = clone(this.mainQuestion.data.mq);
      this.editando = this.mainQuestion.nuevoreg;
    }
  }, {
    key: "editarMainQ",
    value: function editarMainQ() {
      var _this = this;
      this.editando = !this.editando;
      this.$timeout(function () {
        return _this.$element.find('select').formSelect();
      }, 1);
      this.$timeout(function () {
        var textarea = _this.$element.find('.materialize-textarea');
        if (textarea && textarea[0]) M.textareaAutoResize(textarea);
      }, 200);
    }
  }, {
    key: "guardarMainQ",
    value: function guardarMainQ() {
      var _this2 = this;
      var call = this.mainQuestion.nuevoreg ? function () {
        return _this2.AccesoDatos.MainQuestions_CLIENT.altaPregPrincipal({
          mq: _this2.form.data
        });
      } : function () {
        return _this2.AccesoDatos.MainQuestions_CLIENT.editarPregPrincipal(_this2.mainQuestion.data.mq.idmainq, {
          mq: _this2.form.data
        });
      };
      call().then(function (response) {
        _this2.mainQuestion.update(response);
        _this2.form.data = clone(response.mq);
        _this2.dirty = false;
      });
    }
  }, {
    key: "refreshMainQ",
    value: function refreshMainQ() {
      var _this3 = this;
      if (this.mainQuestion.nuevoreg) {
        return;
      }
      this.AccesoDatos.MainQuestions_CLIENT.leerPregPrincipal(this.mainQuestion.data.mq.idmainq) //
      .then(function (response) {
        _this3.mainQuestion.update(response);
        _this3.form.data = clone(response.mq);
        _this3.dirty = false;
      });
    }
  }, {
    key: "cerrarUsosMainQ",
    value: function cerrarUsosMainQ() {
      this.usosData.visible = false;
    }
  }, {
    key: "usosMainQ",
    value: function usosMainQ() {
      var _this4 = this;
      this.AccesoDatos.MainQuestions_CLIENT.usosPregPrincipal(this.mainQuestion.data.mq.idmainq) //
      .then(function (list) {
        _this4.usosData = {
          visible: true,
          leido: true,
          list: list.map(function (l) {
            return new UsosPreg(l);
          })
        };
      });
    }
  }, {
    key: "cerrarUsosPreg",
    value: function cerrarUsosPreg(preg) {
      preg.usosData.visible = false;
    }
  }, {
    key: "usosPregEnForms",
    value: function usosPregEnForms(preg) {
      var pregForm = preg.data.parent || preg.data.preg;
      this.AccesoDatos.Preg_CLIENT.usosPregunta(pregForm.idquest).then(function (list) {
        preg.usosData = {
          visible: true,
          leido: true,
          list: list
        };
      });
    }
  }]);
}();
var UsosPreg = /*#__PURE__*/_createClass(function UsosPreg(data) {
  _classCallCheck(this, UsosPreg);
  _defineProperty(this, "usosData", {
    visible: false,
    leido: false,
    list: []
  });
  this.data = data;
});
angular.module('candidato').component('tarjetaMainQuestion', {
  bindings: {
    mainQuestion: '<'
  },
  controller: TarjetaMainQuestionComponentCtrl,
  // templateUrl: "tarjeta-main-question.component.html",
  template: require('./tarjeta-main-question.component.html')
});